import { Dispatch, SetStateAction, createContext, useCallback, useContext, useState } from 'react';
import { FreeSpins } from 'react-easyrocket';

export const FreeSpinsContext = createContext<{
  oldFreeSpins?: FreeSpins;
  saveFreeSpins?: (freeSpins: FreeSpins) => void;
  freeSpinsChanged?: boolean;
  setFreeSpinsChanged?: Dispatch<SetStateAction<boolean>>;
}>({});

export const useIniFreeSpins = () => {
  const [oldFreeSpins, setOldFreeSpins] = useState<FreeSpins>();
  const [freeSpinsChanged, setFreeSpinsChanged] = useState<boolean>(false);

  const saveFreeSpins = useCallback((freeSpins: FreeSpins) => {
    const fsFromStorage = localStorage.getItem('oldFreeSpin');
    if (fsFromStorage === null) {
      setOldFreeSpins(freeSpins);
      localStorage.setItem('oldFreeSpin', `${freeSpins?.number}`);
    }
    if (fsFromStorage && Number(fsFromStorage) < freeSpins?.number) {
      setFreeSpinsChanged(true);
      setOldFreeSpins(freeSpins);
      localStorage.setItem('oldFreeSpin', `${freeSpins?.number}`);
    }
    if (Number(fsFromStorage) === freeSpins?.number) {
      setOldFreeSpins(freeSpins);
      localStorage.setItem('oldFreeSpin', `${freeSpins?.number}`);
    } else {
      setOldFreeSpins(freeSpins);
      localStorage.setItem('oldFreeSpin', `${freeSpins?.number}`);
    }
  }, []);

  return { oldFreeSpins, saveFreeSpins, freeSpinsChanged, setFreeSpinsChanged };
};

export const useFreeSpins = () => {
  return useContext(FreeSpinsContext);
};
